import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils/utils";
import { Textarea } from "../../ui/textarea";
import { Control, FieldPath, FieldValues } from "react-hook-form";
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "../../ui/form";

// See CommonInput: generic over the caller's field type, not `any`.
interface CommonTextareaProps<TFieldValues extends FieldValues> {
  control: Control<TFieldValues>;
  name: FieldPath<TFieldValues>;
  label: string;
  placeholder?: string;
  className?: string;
  rows?: number;
}
const CommonTextarea = t0 => {
  const $ = _c(9);
  const {
    control,
    name,
    label,
    placeholder,
    className,
    rows: t1
  } = t0;
  const rows = t1 === undefined ? 8 : t1;
  let t2;
  if ($[0] !== className || $[1] !== label || $[2] !== placeholder || $[3] !== rows) {
    t2 = t3 => {
      const {
        field
      } = t3;
      return <FormItem><FormLabel className="font-semibold uppercase">{label}</FormLabel><FormControl><Textarea placeholder={placeholder} rows={rows} {...field} className={cn("common-input resize-none p-4", className)} /></FormControl><FormMessage className="text-[0.65rem] font-bold" /></FormItem>;
    };
    $[0] = className;
    $[1] = label;
    $[2] = placeholder;
    $[3] = rows;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== control || $[6] !== name || $[7] !== t2) {
    t3 = <FormField control={control} name={name} render={t2} />;
    $[5] = control;
    $[6] = name;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
export default CommonTextarea;